import { UserFacingError } from './errors'

export class ExpenseNotFoundError extends UserFacingError {
  constructor() {
    super('Expense not found.')
    this.name = 'ExpenseNotFoundError'
  }
}

export class InvalidReviewTransitionError extends UserFacingError {
  constructor(message: string) {
    super(message)
    this.name = 'InvalidReviewTransitionError'
  }
}

export class DuplicateCategoryNameError extends UserFacingError {
  constructor() {
    super('A category with that name already exists.')
    this.name = 'DuplicateCategoryNameError'
  }
}

export class CategoryNotFoundError extends UserFacingError {
  constructor() {
    super('Expense category not found.')
    this.name = 'CategoryNotFoundError'
  }
}

export class InvalidBookingError extends UserFacingError {
  constructor() {
    super('The selected booking is not valid for this expense.')
    this.name = 'InvalidBookingError'
  }
}

export class FutureExpenseDateError extends UserFacingError {
  constructor() {
    super('Expense date cannot be in the future.')
    this.name = 'FutureExpenseDateError'
  }
}

export class InvalidReceiptPathError extends UserFacingError {
  constructor() {
    super('The receipt path is invalid or the file was not uploaded.')
    this.name = 'InvalidReceiptPathError'
  }
}

export class OrgNotFoundError extends UserFacingError {
  constructor() {
    super('Organization not found.')
    this.name = 'OrgNotFoundError'
  }
}

export class UnauthorizedExpenseActionError extends UserFacingError {
  constructor() {
    super('You are not authorized to perform this action.')
    this.name = 'UnauthorizedExpenseActionError'
  }
}

export class ExpenseNotEditableError extends UserFacingError {
  constructor() {
    super('This expense can no longer be edited.')
    this.name = 'ExpenseNotEditableError'
  }
}
